module.exports = __webpack_public_path__ + "img/DE02645.8141cebb.png";